import { ReactComponent as AccountVerticalBrand } from './assets/icons/account.svg';
import { ReactComponent as AccountFilledVerticalBrand } from './assets/icons/account-filled.svg';
import { ReactComponent as CartVerticalBrand } from './assets/icons/cart.svg';

export default {
    AccountVerticalBrand,
    AccountFilledVerticalBrand,
    CartVerticalBrand,
};
